const config = {
    API_URL: "https://api.glassyfied.com",
    QUERY_DEV_TOOLS_ENABLED: false,
    MAX_MESSAGES: 100,
    SOCKET_CONNECTION_INDICATOR_ENABLED: false,
    SOCKET_CONNECTION_URL: "wss://api.glassyfied.com/ws",
    SECRET_KEY: "ProdEncryptionKey",
};

export default config;
